<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      tableTitle="Routing rules"
      :fields="[
      { header: 'Description', prop: 'description' }
      ]"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'RoutingRuleSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        fields: [
          { header: 'Description', prop: 'description' }
        ],
        loading: false,
        tableData: [],
        entityName: 'routing-rules',
        editEntityScreen: 'Admin - Edit/View Routing Rule',
        shouldSearchForExactMatch: false,
        orderBy: 'description'
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// RoutingRuleSearchResults.vue?65ea7ea7